import React, { useState , useEffect, useContext} from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Button, Card , Form , Row , Col,Spinner} from 'react-bootstrap';
import logo from '../../assets/logo_rushters_negro.png';
import Image from 'react-bootstrap/Image';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import * as Icon from 'react-bootstrap-icons';
import favicon from '../../assets/favicon.ico'
import localities from './localities.json'
import { useRut , isValid} from 'react-rut';
import { PartnersContext } from '../../PartnersContext';
const Register = () => {
    const {partner,setPartner,partnerRegister, rutExist , emailExist} = useContext(PartnersContext);
    const [validated, setValidated] = useState(false);
    const [regForm, setRegForm] = useState(1);
    const [comuna, setComuna] = useState([]);
    const [{ formattedValue }, setRut] = useRut();
    const [rutCheck,setRutCheck] = useState(false);
    const [checkEmail, setCheckEmail] = useState(false);
    const [emailRepeat, setEmailRepeat] = useState('');
    const [partnerOk, setPartnerOk] = useState(false);
    const [loading, setLoading] = useState(false);


    useEffect( () => {
       setPartner({...partner,rut:formattedValue});


    },[formattedValue]);

     const changeForm = () => {

        if (regForm === 1){
            setValidated(true);
            const  form_object = document.getElementById("formRegister");
            if (form_object.checkValidity() === false || isValid(formattedValue) === false || comuna.length == 0 || checkEmail || rutCheck)  {
                setRegForm(1)
            }else{
                setPartner({...partner,comuna:comuna[0]})
                setRegForm(2)
            }

        }else if(regForm === 2) {
            setRegForm(1)
        }
     }

     const checkIfRutExist = () =>{
        if(isValid(partner.rut)){
            rutExist()
            .then(result =>  setRutCheck(result))
            .catch(error => console.error('Error fetching data:', error));
       }
     }

     const checkIfEmailExist = () =>{
        emailExist()
        .then(result =>  setCheckEmail(result))
        .catch(error => console.error('Error fetching data:', error));

     }


    const register = (event) => {
        const form = event.currentTarget;
        setLoading(true);
        setValidated(true);
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === false || isValid(formattedValue) === false)  {
            setLoading(false);
            return 0;
        }

        try{
            partnerRegister();
            setPartnerOk(true);
            setLoading(false);
        }catch(e){
            console.log(e);
            setLoading(false);

        }

    };


    const spinerRush  =  <Spinner className="align-middle" animation="grow"   variant="dark" role="status">
                        <Image rounded width={20} height={20} src={favicon} />
                    </Spinner>;

    return (
        <>
            <Navbar bg="dark"  expand="lg" className="bg-body-tertiary" data-bs-theme="dark">
                <Container fluid>
                </Container>
            </Navbar>
            <Container>
                <Row>
                    <Col xs={1} md={2} lg={3} ></Col>
                    <Col xs={10} md={8} lg={6}>
                    <div className='pt-5'>
                            <Card className="text-center " >
                                <Card.Header className='titleDefault' >
                                    <Image fluid src={logo} width={200} height={40}/>
                                </Card.Header>
                                <Card.Body>
                                    <Card.Title className='titleDefault pb-2'></Card.Title>
                                    {loading && spinerRush}
                                    <Form  noValidate validated={validated} onSubmit={register} id="formRegister">
                                        { !partnerOk && regForm === 1 &&
                                         <>
                                            <Form.Group as={Row} className="mb-3" controlId="partnerName">
                                                <Form.Label column sm={2} md={3}>

                                                </Form.Label>
                                                <Col sm={8} md={6}>
                                                <Form.Control
                                                type="text"
                                                placeholder="Razón social"
                                                onChange={(event) => setPartner({...partner,name:event.currentTarget.value})}
                                                value={partner.name}
                                                required
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Ingresa una razón social
                                                </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3" controlId="partnerRut">
                                                <Form.Label column  sm={2} md={3}>

                                                </Form.Label>
                                                <Col  sm={8} md={6}>

                                                <Form.Control
                                                type="text"
                                                placeholder="Rut empresa"
                                                value={formattedValue}
                                                onChange={(e) => setRut(e.target.value)}
                                                onBlur ={checkIfRutExist}
                                                required
                                                isInvalid={formattedValue.length>1 && !isValid(formattedValue) }
                                                maxLength={12}
                                                minLength={11}
                                                />
                                                <Form.Control.Feedback  type="invalid">
                                                    Ingresa un rut válido
                                                </Form.Control.Feedback>
                                                {
                                                    rutCheck && <span>Error en el RUT ingresado</span>
                                                }
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="partnerEmail">
                                                <Form.Label column sm={2} md={3}>

                                                </Form.Label>
                                                <Col  sm={8} md={6}>
                                                <Form.Control
                                                type="email"
                                                placeholder="Email"
                                                onChange={(event) => setPartner({...partner,correo:event.currentTarget.value})}
                                                onBlur={checkIfEmailExist}
                                                value={partner.correo}
                                                isInvalid={checkEmail}
                                                required
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Ingresa un email válido
                                                </Form.Control.Feedback>

                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="partnerGiro">
                                                <Form.Label column sm={2} md={3}>

                                                </Form.Label>
                                                <Col sm={8} md={6}>
                                                <Form.Control
                                                type="text"
                                                placeholder="Giro"
                                                onChange={(event) => setPartner({...partner,giro:event.currentTarget.value})}
                                                value={partner.giro}
                                                required
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Ingresa un giro válido
                                                </Form.Control.Feedback>

                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="partnerDireccion">
                                                <Form.Label column sm="2" md={3}>

                                                </Form.Label>
                                                <Col sm="8" md="6">
                                                <Form.Control
                                                type="text"
                                                placeholder="Dirección comercial"
                                                onChange={(event) => setPartner({...partner,direccion:event.currentTarget.value})}
                                                value={partner.direccion}
                                                required
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Ingresa una dirección válida
                                                </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="partnerComuna">
                                                <Form.Label column sm={2} md={3}></Form.Label>
                                                <Col sm={8} md={6}>
                                                    <Typeahead
                                                        id='partnerComuna'
                                                        onChange={(selected) => setComuna(selected)}
                                                        options={localities.comunas}
                                                        placeholder="Comuna"
                                                        labelKey="value"
                                                        selected={comuna}
                                                        />

                                                    <Form.Control.Feedback type="invalid">
                                                        Ingresa una comuna válida
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="partnerServicio">
                                                <Form.Label column sm="2" md={3}>

                                                </Form.Label>
                                                <Col sm={8} md={6}>
                                                    <Form.Select aria-label="Servicio"
                                                        onChange={(event) => setPartner({...partner,servicio:event.currentTarget.value})}
                                                        value={partner.servicio}
                                                        required
                                                    >
                                                        <option value={""}>Servicio</option>
                                                        <option value='batery'>Baterías</option>
                                                        <option value='brakes'>Frenos</option>
                                                        <option value='lubricants'>Lubricantes</option>
                                                        <option value="tires" >Neumáticos</option>
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingresa un servicio válido
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>

                                            <Button  className='mt-3 mb-3 btn btn-sm btn-block btn-danger' onClick={ () => changeForm() } type='button' >
                                                Continuar registro
                                            </Button>
                                         </>
                                        }

                                        {
                                            !partnerOk && regForm === 2 &&
                                            <div>
                                                <h5>Ingresa tu correo eléctronico para proceder a crear tu cuenta</h5>

                                                <Form.Group as={Row} className="mb-3" controlId="partnerEmailRepeat">
                                                <Form.Label column sm="2" md={3}>

                                                </Form.Label>
                                                <Col sm="8" md={6}>
                                                <Form.Control
                                                type="email"
                                                placeholder="Confirma tu correo de empresa"
                                                onChange={(event) => setEmailRepeat(event.currentTarget.value)}
                                                value={emailRepeat}
                                                required
                                                isInvalid={emailRepeat.length >1 && emailRepeat !== partner.correo}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                Los correos empresa no coiciden
                                                </Form.Control.Feedback>

                                                </Col>
                                            </Form.Group>

                                            <Button  className='mt-3 mb-3 btn btn-sm btn-block btn-danger' type='submit' >
                                            Unirse a RUSHTERS
                                            </Button>
                                            <hr></hr>

                                            <span>
                                             Si no recibes el email de bienvenida contactanos en: contacto@rushters.com
                                            </span>
                                            <br></br>
                                            <a type='button' href="#"  onClick={ () => changeForm() }  className='link'><span></span>Volver</a>

                                         </div>
                                        }
                                    </Form>
                                    {
                                        partnerOk &&
                                            <Row>
                                            <Col xs={1} md={2} lg={3} ></Col>
                                            <Col xs={10} md={8} lg={6}></Col>
                                                <h5>
                                                    <Icon.CheckCircle></Icon.CheckCircle>&nbsp;
                                                     Comercio registrado con éxito, revisa el correo:
                                                    <p>{partner.correo}</p>
                                                     para continuar con el registro.
                                                </h5>

                                            </Row>

                                    }
                                </Card.Body>
                            </Card>

                    </div>
                    </Col>
                    <Col xs={1} md={2} lg={3}></Col>

                </Row>
            </Container>


        </>

    );
};

export default Register;